import NewListing from './NewListing';

export default NewListing;
